/* dcent-faq — accordion hydration. Toggles .is-open + animates max-height. */
/* Scoped to the `.dcent-qa*` namespace (distinct from the `.dcent-faq` <details> convention). */
(function () {
  function initFaq(container) {
    if (container.dataset.dcentQaInit) return;
    container.dataset.dcentQaInit = "1";
    container.querySelectorAll("[data-dcent-qa-q]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = btn.closest(".dcent-qa__item");
        if (!item) return;
        var panel = item.querySelector(".dcent-qa__a");
        var open = item.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        if (panel)
          panel.style.maxHeight = open ? panel.scrollHeight + "px" : "0px";
      });
    });
  }

  function init() {
    document.querySelectorAll("[data-dcent-qa]").forEach(initFaq);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
